/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable indent */
/* eslint-disable camelcase */
import React, { useState, useEffect, useCallback } from 'react';
import { useQuery } from '@apollo/client';
import {
  Grid,
  MenuItem,
  InputLabel,
  Button,
  Select,
  TextField,
  Checkbox,
  FormControlLabel,
  Switch,
} from '@material-ui/core';
import moment from 'moment';
import { setLanguageLabel } from 'pages/labels/languageLabels';
import SelectTitlesToPresell from 'components/SelectTitlesToPresell/SelectTitlesToPresell';
import { contentLanguages } from 'components/CreateContentTranslation/contentLanguages';
import { getStatusTextLabel } from 'pages/labels';
import { SelectProductTypes } from 'pages/categorization/productTypes/components/SelectProductTypes';
import useStyles from './styles';
import { getFriendlyErrorMessage } from '../../../utils/errorHelper';
import { BackDateType } from '../../../enums/backDate.enum';
import {
  SitesAutocomplete,
  CountriesAutocomplete,
} from '../../../components/Autocomplete';
import { Toast } from '../../../components/Toast';
import {
  SelectCategories,
  AddCategories,
} from '../../../components/Categories';
import { SelectBrands } from '../../categorization/brands/components/SelectBrands';
import { SelectProducts } from '../../categorization/products/components/SelectProducts';
import { StatusType } from '../../../enums/status-type.enum';
import { CreatedBy, WrittenBy } from '../../../components/TitleInfo';
import { tags, getTagValue } from '../../../components/DisplayTag/tags';
import { SelectWriters } from '../../../components/Writers';
import { niches, getNicheValue } from '../../../components/DisplayNiche/niches';
import { usePermissions } from '../../../store/permissions.context';
import { useUserData } from '../../../hooks/context/userUserData.hook';
import { GET_TAGS } from '../../../queries/tag';
import { ArticleType } from '../../../enums/articleType.enum';
import { UserRolesTypes } from '../../../enums/userRoles.enum';

interface ITitlesFormProps {
  data?: any;
  query_f: (variables: any) => Promise<any>;
}

const TitlesForm: React.FC<ITitlesFormProps> = ({ data, query_f }) => {
  const [permissions] = usePermissions();
  const [user] = useUserData();

  const [id] = useState(data?.id || null);
  const [title, setTitle] = useState(data?.title || '');
  const [niche, setNiche] = useState(data?.niche || '');
  const [language, setLanguage] = useState(data?.language || '');
  const [focusKeyword, setFocusKeyword] = useState(data?.focusKeyword || '');
  const [suggestedKeywords, setSuggestedKeywords] = useState(
    data?.suggestedKeywords || '',
  );
  const [researchLinks, setResearchLinks] = useState(data?.researchLinks || '');
  const [status, setStatus] = useState(
    data && data.status >= 0 ? parseInt(data.status, 10) : 1,
  );
  const [premise, setPremise] = useState(data?.premise || '');
  const [comments, setComments] = useState(data?.comments || '');
  const [countries, setCountries] = useState(data?.countries || []);
  const [tag, setTag] = useState(data?.tag || '');
  const [listTags, setListTags] = useState<ITag[]>([]);
  const [backDate, setBackDate] = useState(
    data?.backDate || BackDateType.NoBackDate,
  );
  const [otherReason, setOtherReason] = useState(data?.otherReason || '');
  const [contentManagerId] = useState(data?.contentManagerId || '');
  const [categoriesIds, setCategoriesIds] = useState(data?.categories || []);
  const [titlesToPresellIds, setTitlesToPresellIds] = useState(
    data?.titlesToPresell || [],
  );
  const [reason, setReason] = useState(
    data?.reason ? parseInt(data.reason, 10) : 0,
  );
  const [writerId, setWriterId] = useState(data?.writerId || '');
  const [siteDomain, setSiteDomain] = useState(data?.siteDomain || '');
  const [publishPost, setPublishPost] = useState(data?.publishPost || '');
  const [deadline, setDeadline] = useState(data?.deadline || '');
  const [publishPostDate, setPublishPostDate] = useState('');
  const [publishNow, setPublishNow] = useState(false);
  const [pagination, setPagination] = useState(data?.pagination || false);
  const [brandId, setBrandId] = useState(data?.brandId || null);
  const [productTypeId, setProductTypeId] = useState(
    data?.productTypeId || null,
  );
  const [productId, setProductId] = useState(data?.productId || null);
  const [createdBy] = useState(data?.createdBy || '');
  const [writtenBy] = useState(data ? data.writerId || data.editorId : '');
  const [articleType, setArticleType] = useState(data?.articleType);

  const [errorWriter, setErrorWriter] = useState(false);
  const [errorTag, setErrorTag] = useState(false);
  const [errorLanguage, setErrorLanguage] = useState(false);
  const [errorTitle, setErrorTitle] = useState(false);

  const { data: tagsContentData } = useQuery(GET_TAGS, {
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (tagsContentData) {
      setListTags(tagsContentData.listTags);
    }
  }, [tagsContentData]);

  const classes = useStyles();

  const getPublishPost = useCallback(
    (publishNow = false) => {
      let date;
      if (publishPost) {
        date = moment(publishPost, 'YYYY-MM-DD').format('YYYY-MM-DD');
      } else {
        date = moment().format('YYYY-MM-DD');
      }
      if (publishNow) {
        date = moment().format('YYYY-MM-DD');
      }
      return date;
    },
    [publishPost],
  );

  const publishNowCheckbox = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setPublishNow(ev.target.checked);
    setPublishPostDate(getPublishPost(ev.target.checked));
    setPublishPost(getPublishPost(ev.target.checked));
  };

  useEffect(() => {
    setPublishPostDate(getPublishPost());
  }, [getPublishPost]);

  const handleChange = (
    set: React.Dispatch<any>,
    event: React.ChangeEvent<any>,
  ) => {
    set(event.target.value);
  };

  const handleChangeWriter = (newWriterId: string) => {
    setWriterId(newWriterId);

    if (newWriterId) {
      const newDeadlineDate = moment().add(1, 'day').format('YYYY-MM-DD');
      setDeadline(newDeadlineDate);
    }
  };

  // Status is WaitPublish statusWP is PublishPending(3) otherwise DraftPending(2)
  const setStatusWP = (status: number) => {
    return status === StatusType.WaitPublish ? 3 : 2;
  };

  const checkStatusWriter = (status: number, writerId: string) => {
    setErrorWriter(false);
    if (status === StatusType.Approved && (!writerId || !writerId.length)) {
      Toast('Approved Title must have a Writer', 'warning');
      setErrorWriter(true);
      return false;
    }
    return true;
  };

  const checkRequiredFields = ({
    status,
    writerId,
    tag,
    title,
    premise,
  }: {
    status: number;
    writerId: string;
    tag: string;
    title: string;
    premise: string;
  }) => {
    let hasError = false;
    setErrorTag(false);
    setErrorLanguage(false);
    setErrorTitle(false);

    if (!premise && !checkStatusWriter(status, writerId)) {
      hasError = true;
    }

    if (premise && !language) {
      setErrorLanguage(true);
      Toast('Language is required', 'warning');
      hasError = true;
    }

    if (!tag || !tag.length) {
      setErrorTag(true);
      Toast('Tag is required', 'warning');
      hasError = true;
    }

    if (!title || !title.length) {
      setErrorTitle(true);
      Toast('Title is required', 'warning');
      hasError = true;
    }

    if (hasError) {
      return false;
    }

    return true;
  };

  const saveContent = (status: number) => {
    const values = {
      id,
      siteDomain,
      title,
      niche,
      writerId: user.role === UserRolesTypes.Translator ? user.id : writerId,
      status,
      reason,
      premise,
      comments,
      categories: categoriesIds,
      publishPost: publishPost
        ? moment(publishPost, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm:ss')
        : moment().format('YYYY-MM-DD HH:mm:ss'),
      researchLinks,
      focusKeyword,
      suggestedKeywords,
      contentManagerId:
        user.role === UserRolesTypes.ContentManager
          ? user.id
          : contentManagerId,
      photos: [''],
      statusAtWP: setStatusWP(status),
      tag,
      countries,
      otherReason,
      backDate: parseInt(backDate, 10),
      pagination,
      brandId: brandId || '',
      productId: productId || '',
      articleType,
      language,
      deadline,
      titlesToPresell: titlesToPresellIds,
      productTypeId,
    };

    if (checkRequiredFields(values)) {
      query_f({
        variables: values,
      }).then(
        () => {
          Toast('Action executed with success!');

          if (values.premise && values.premise.length > 0) {
            setTimeout(() => {
              Toast(
                'Since the “Premise” field has been filled in, the “Content” title will be generated automatically',
                'warning',
              );
            }, 3000);
          }
        },
        (error) => {
          Toast(getFriendlyErrorMessage(error), 'error');
        },
      );
    }
  };

  return (
    <form id="myForm">
      <Grid container spacing={1}>
        <SitesAutocomplete
          setSelectedSite={setSiteDomain}
          selectedSite={siteDomain}
          disabled={tag === 'gm'}
        />
        <Grid item className={classes.actionButtons} xs={2}>
          <Button
            onClick={() => saveContent(status)}
            fullWidth
            variant="contained"
            className={classes.btnSave}
          >
            Save
          </Button>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="title"
            label="title"
            color="primary"
            error={errorTitle && (!title || !title.length)}
            onChange={(e) => handleChange(setTitle, e)}
            value={title}
            fullWidth
            className={classes.inputLabel}
            multiline={id === null}
            InputLabelProps={{ shrink: true }}
            placeholder=""
          />
        </Grid>
        <Grid item xs={10}>
          <SelectCategories
            categoriesIds={categoriesIds}
            setCategoriesIds={setCategoriesIds}
            siteDomain={siteDomain}
          />
        </Grid>
        {permissions.showAddCategories ? (
          <Grid item xs={2}>
            <AddCategories
              siteDomain={siteDomain}
              setSiteDomain={setSiteDomain}
            />
          </Grid>
        ) : (
          <></>
        )}
        <Grid item xs={12}>
          <InputLabel className={classes.inputLabel}>Niche</InputLabel>
          <Select
            fullWidth
            id="niche"
            labelId="select-settings-niche"
            onChange={(e) => handleChange(setNiche, e)}
            value={niche}
          >
            {Object.keys(niches).map((label) => (
              <MenuItem value={getNicheValue(label)} key={label}>
                {label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={10}>
          <InputLabel
            error={errorTag && (!tag || !tag.length)}
            className={classes.inputLabel}
          >
            Tag
          </InputLabel>
          <Select
            fullWidth
            id="tag"
            labelId="select-settings-tag"
            onChange={(e) => handleChange(setTag, e)}
            value={tag}
          >
            {Object.keys(tags).map((label) => (
              <MenuItem value={getTagValue(label)} key={label}>
                {label}
              </MenuItem>
            ))}
            {listTags.map((tag) => (
              <MenuItem key={tag.id} value={tag.name}>
                {tag.name.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        {permissions.showPagination ? (
          <Grid item xs={2}>
            <InputLabel className={classes.labelCenter}>Pagination</InputLabel>
            <Switch
              checked={pagination}
              color="primary"
              onClick={() => setPagination(!pagination)}
              name="checkedA"
              inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
          </Grid>
        ) : (
          <></>
        )}

        {tag === 'ar' && (
          <Grid item xs={12}>
            <InputLabel className={classes.inputLabel}>Article Type</InputLabel>
            <Select
              fullWidth
              id="articleType"
              onChange={(e) => handleChange(setArticleType, e)}
              value={articleType}
            >
              <MenuItem value={ArticleType.Educational}>
                Educational Article
              </MenuItem>
              <MenuItem value={ArticleType.Listing}>Listing Article</MenuItem>
              <MenuItem value={ArticleType.Presell}>Presell Article</MenuItem>
            </Select>
          </Grid>
        )}

        {articleType === ArticleType.Presell && (
          <Grid item xs={12}>
            <SelectTitlesToPresell
              titlesToPresellIds={titlesToPresellIds}
              setTitlesToPresellIds={setTitlesToPresellIds}
              siteDomain={siteDomain}
            />
          </Grid>
        )}

        {permissions.showWriters ? (
          <SelectWriters
            writerId={writerId}
            status={status}
            onChangeWriter={handleChangeWriter}
            error={errorWriter}
          />
        ) : (
          <></>
        )}
        {permissions.showStatus ? (
          <Grid item xs={12}>
            <InputLabel className={classes.inputLabel}>Status</InputLabel>
            <Select
              fullWidth
              id="status"
              labelId="select-settings-status"
              onChange={(e) => handleChange(setStatus, e)}
              value={status}
            >
              {Object.values(getStatusTextLabel).map((status, index) => (
                <MenuItem value={index} key={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        ) : (
          <></>
        )}
        {permissions.statusToRejectReason === status && (
          <Grid item xs={12}>
            <InputLabel className={classes.inputLabel}>Reason</InputLabel>
            <Select
              fullWidth
              id="reason"
              labelId="select-settings-reason"
              onChange={(e) => handleChange(setReason, e)}
              value={reason}
            >
              <MenuItem value={0} key="Reason0">
                None
              </MenuItem>
              <MenuItem value={1} key="Reason1">
                Duplicated
              </MenuItem>
              <MenuItem value={2} key="Reason2">
                Audience is not specified
              </MenuItem>
              <MenuItem value={3} key="Reason3">
                Other
              </MenuItem>
            </Select>
          </Grid>
        )}
        {permissions.statusToRejectReason === status &&
          permissions.reasonToOtherReason === reason && (
            <Grid item xs={12}>
              <TextField
                id="otherReason"
                label="Other reason"
                onChange={(e) => handleChange(setOtherReason, e)}
                value={otherReason}
                color="primary"
                fullWidth
              />
            </Grid>
          )}
        <Grid item xs={12}>
          <TextField
            id="premise"
            label="premise"
            onChange={(e) => handleChange(setPremise, e)}
            value={premise}
            color="primary"
            multiline
            rows={4}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="comments"
            label="comments"
            onChange={(e) => handleChange(setComments, e)}
            value={comments}
            color="primary"
            fullWidth
          />
        </Grid>
        {permissions.showBackDate ? (
          <Grid item xs={12}>
            <InputLabel className={classes.inputLabel}>Back Date</InputLabel>
            <Select
              fullWidth
              id="backDate"
              labelId="select-back-date"
              onChange={(e) => handleChange(setBackDate, e)}
              value={backDate}
            >
              <MenuItem value="-1" key="-1">
                No Back Date
              </MenuItem>
              <MenuItem value="1" key="1">
                1 Month
              </MenuItem>
              <MenuItem value="2" key="2">
                2 Months
              </MenuItem>
              <MenuItem value="7" key="7">
                7 Months
              </MenuItem>
              <MenuItem value="12" key="12">
                1 Year
              </MenuItem>
              <MenuItem value="24" key="24">
                2 Years
              </MenuItem>
              <MenuItem value="36" key="36">
                3 Years
              </MenuItem>
              <MenuItem value="48" key="48">
                4 Years
              </MenuItem>
              <MenuItem value="60" key="60">
                5 Years
              </MenuItem>
            </Select>
          </Grid>
        ) : (
          <></>
        )}

        <Grid item xs={12}>
          <TextField
            id="deadline"
            label="deadline"
            onChange={(e) => handleChange(setDeadline, e)}
            type="date"
            InputProps={{
              inputProps: { min: moment().format('YYYY-MM-DD') },
            }}
            value={moment(deadline, 'YYYY-MM-DD').format('YYYY-MM-DD')}
            color="primary"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            className={classes.inputLabel}
          />
        </Grid>

        {parseInt(backDate, 10) === BackDateType.NoBackDate && (
          <Grid container>
            <Grid item xs={permissions.showPublishNow ? 9 : 12}>
              <TextField
                id="publish post"
                label="publish post"
                onChange={(e) => handleChange(setPublishPost, e)}
                type="date"
                InputProps={
                  {
                    // inputProps: { min: moment().format('YYYY-MM-DD') },
                  }
                }
                value={publishPostDate}
                color="primary"
                fullWidth
                disabled={publishNow}
                InputLabelProps={{
                  shrink: true,
                }}
                className={classes.inputLabel}
              />
            </Grid>
            {permissions.showPublishNow ? (
              <Grid item xs={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={publishNow}
                      onChange={publishNowCheckbox}
                      name="publish-now"
                    />
                  }
                  label="PUBLISH NOW"
                  labelPlacement="top"
                />
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        )}
        <Grid item xs={12}>
          <InputLabel className={classes.inputLabel} error={errorLanguage}>
            Language
          </InputLabel>
          <Select
            fullWidth
            id="language"
            labelId="select-settings-langague"
            onChange={(e) => handleChange(setLanguage, e)}
            value={language}
          >
            {contentLanguages.map((language: any) => (
              <MenuItem value={language.code} key={language.code}>
                {setLanguageLabel(language.code)}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="focusKeyword"
            label="Focus Keyword"
            onChange={(e) => handleChange(setFocusKeyword, e)}
            value={focusKeyword}
            color="primary"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="suggestedKeywords"
            label="Related Keywords"
            onChange={(e) => handleChange(setSuggestedKeywords, e)}
            value={suggestedKeywords}
            color="primary"
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="researchLinks"
            label="Research Links"
            onChange={(e) => handleChange(setResearchLinks, e)}
            value={researchLinks}
            color="primary"
            fullWidth
          />
        </Grid>
        {permissions.showCountries ? (
          <CountriesAutocomplete
            selectedCountries={countries}
            setSelectedCountries={setCountries}
          />
        ) : (
          <></>
        )}

        {permissions.showBrandsTitles ? (
          <Grid item xs={12}>
            <SelectBrands
              brandId={brandId}
              setBrandId={setBrandId}
              brandsFetchPolicy="cache-and-network"
            />
          </Grid>
        ) : (
          <></>
        )}

        {permissions.showProductType && (
          <Grid item xs={12}>
            <SelectProductTypes
              productTypeId={productTypeId}
              setProductTypeId={setProductTypeId}
            />
          </Grid>
        )}

        {permissions.showProductsTitles &&
        brandId !== '' &&
        brandId !== null ? (
          <Grid item xs={12}>
            <SelectProducts
              brandId={brandId}
              productId={productId}
              setProductId={setProductId}
            />
          </Grid>
        ) : (
          <></>
        )}
        <CreatedBy createdBy={createdBy} />
        <WrittenBy writtenBy={writtenBy} />
      </Grid>
    </form>
  );
};

export default TitlesForm;
